export default (numberOfJobs, theme) => ({
  bottomCart: false,
  busy: false,
  numberOfJobs,
  theme,

  quickSearch() {
    Turbo.visit('/search')
  },
})
